import React, { Component } from "react";
import Header from "Orgs/Header";
import { returnHomeKeyUp } from "../../../../utils/returnHomeBtn"


// TODO: REWRITE COMPONENT TO USE THE HISTORY PROP FROM REDUX


class Error extends Component {

  componentDidMount(){
      if(global.digitalData){
          global.digitalData.page.pageInfo.pageName = "Error Page";
      }
  }


  render(){
    return (
      <div className="com-errorpage">
    		<Header />

    		<div className="error-main">
    			<div className="dx-col">
    				<header> Something&#39;s amiss </header>
    				<div className="header-info">
    					And it appears the issue is on our end.
    				</div>
    				<div className="header-accent"></div>

                    <div className="text-block">
                        If you recently attempted to make a payment and have not received your confirmation number,<strong> please do not attempt another payment</strong>&#46;
                    </div>
                    <div className="text-block">
                        Please call our customer help line <strong><a href="tel:+1-888-978-5371" tabindex="0">1-888-978-5371</a></strong>.<br/>Our team is available Mon-Fri 8 am to 8:30 pm ET.
                    </div>
                    <div className="text-block">
                        <strong>We know your time is valuable, and we apologize for the inconvenience. </strong>
                    </div>
    				<div className="button-area return-home-btn" onClick={() => this.props.history.push('/')} onKeyUp={returnHomeKeyUp(this.props.history)}>
    					<button className="secondary">Return to AIG&#46;com</button>
    				</div>
    			</div>
    		</div>
    	</div>
    )
  }

}

export default Error;



// WEBPACK FOOTER //
// ./src/components/atomic/pages/Error/Error.js